export const PHONE_VERIFICATION_TOOLTIP_MESSAGE = "Must complete adding a phone number before you can verify"
export const EMPTY_MESSAGE = ""
export const FEATURE_NOT_AVAILABLE_FOR_USER_MESSAGE = "This feature is not available for this user!"
export const RBALOCK_MUST_BE_FULLY_UNLOCKED_TOOLTIP_MESSAGE = "Member’s RBA state must be Fully Unlocked to use this function"
export const PHONE_NO_AS_RECOVERY_TOOLTIP_MESSAGE = "Member has elected Phone number as their recovery option"